export default __webpack_public_path__ + "static/frame-26f98fa66876e9dfed54cbe17bbb9b5c.png";